module.exports = __webpack_public_path__ + "img/tournesol.8d9da515.jpg";